import { actionTypes } from 'data'
import { put, takeEvery } from 'redux-saga/effects'

import { setSettings } from './actions'

function* readConfig() {
  const settings = {
    orderFilledSound: localStorage.getItem('userSettings.orderFilledSound') !== 'false'
  }
  yield put(setSettings(settings))
}

function* writeConfig(action) {
  const settings = action.payload
  localStorage.setItem('userSettings.orderFilledSound', String(settings.orderFilledSound))
  yield put(setSettings(action.payload))
}

export default function* localSettingsMain() {
  yield takeEvery(actionTypes.app.BOOTSTRAP, readConfig)
  yield takeEvery(actionTypes.auth.localSettings.READ_SETTINGS, readConfig)
  yield takeEvery(actionTypes.auth.localSettings.WRITE_SETTINGS, writeConfig)
}
